import DashboardActionTypes from 'app/dashboard/ActionTypes';
import reducer from 'app/dashboard/reducer';
import routes from 'app/dashboard/routes';

export default {
  reducers: {
    dashboard: reducer,
  },
  actionTypes: DashboardActionTypes,
  routes,
};
